import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { Card, LinkButton } from "components";

export const Tips = () => {
  const config = [
    {
      id: "1",
      title: "Išmokite „skaityti“ savo verslo finansinius rodiklius",
      text: (
        <span>
          Esminė sėkmingo verslo sąlyga - laisvai naviguoti tarp finansinių pasirinkimų. Žinios ir informacija padeda
          suprasti skirtingus jūsų įmonės finansų aspektus, leidžia numatyti galimą finansinę ateitį ir prireikus -
          pasinaudoti finansinėmis paslaugomis, siekiant verslą valdyti efektyviau.
        </span>
      ),
      readMore: "https://blog.swedbank.lt/verslas/kas-yra-imones-finansine-sveikata-ir-kaip-ja-pagerinti",
    },
    {
      id: "2",
      title: "Planuokite įmonės finansus",
      text: (
        <span>
          Parenkite trumpalaikius finansinius planus. Jų tikslas - subalansuoti einamuosius pajamų ir išlaidų srautus,
          įskaitant grynuosius pinigus, mokėtinas ir gautinas sumas bei atsargas. Žinodami savo išlaidas, lengviau
          išvengsite vėlavimų. Ilgalaikius finansinius planus kurkite atsižvelgdami į plėtros planus, įskaitant įvairias
          vidines iniciatyvas, išmokas darbuotojams ir pan.
        </span>
      ),
    },
    {
      id: "3",
      title: "Sukaupkite finansinį rezervą",
      text: (
        <span>
          Užsitikrinkite, kad jūsų įmonė galėtų sklandžiai veikti, susidūrusi su netikėtu išlaidų padidėjimu ar
          finansinių srautų sumažėjimu. Tam galėtų pasitarnauti taupymui skirta banko sąskaita. Rekomenduojama
          pirmiausia atidėti bent po 10 proc. mėnesinio pelno, kol sukaupsite finansinį rezervą, lygų 6 mėnesių kintamų
          išlaidų dydžiui. Turėdami išgyvenimo strategiją, net ir nenumatytomis aplinkybėmis galėtumėte išmokėti
          atlyginimus darbuotojams ir padengti kitus svarbius įsipareigojimus.
        </span>
      ),
    },
    {
      id: "4",
      title: "Investuokite pelningai",
      text: (
        <span>
          Investuokite tik į tokius sprendimus, kurie jūsų įmonei sukurtų papildomų pajamų (pelno). Šia taisykle
          <Typography color="primary" variant="body2" fontWeight="700" component="span">
            {" "}
            vadovaukitės ir kurdami naujus produktus bei paslaugas
          </Typography>
          , įgyvendindami rinkodaros kampanijas ar formuodami portfelines investicijas. Įvertinkite ir žinokite, koks
          kiekvienos verslo srities (kaštų centro), produkto ar paslaugos pelningumas. Galbūt verta sumažinti mažiau
          pelningų projektų apimtis ir padidinti didesnę grąžą sukuriančių projektų skaičių.
        </span>
      ),
    },
    {
      id: "5",
      title: "Stebėkite savo įmonės finansus ir naudokitės finansinėmis paslaugomis",
      text: (
        <span>
          Finansų planavimas neatsiejamas nuo jų stebėjimo. Įsivardinkite tinkamus ir tikslius veiklos rodiklius, kad
          galėtumėte stebėti savo įmonės finansinę padėtį. Bendradarbiaukite su įmonės finansininku, jis gali padėti
          sukurti jums suprantamus ir naudingus ruošinius bei ataskaitas.
        </span>
      ),
    },
    {
      id: "6",
      title: "Išorinio finansavimo ieškokite kuo anksčiau, jei planuojate sparčią plėtrą",
      text: (
        <span>
          Investuodami visą savo turtą galite netekti nenumatytiems atvejams sukaupto rezervo, o tai pablogins jūsų
          skolinimosi galimybes, kadangi neturėsite lėšų užtikrinti verslo tęstinumą ir augimą.
        </span>
      ),
      readMore: "https://blog.swedbank.lt/verslas/kas-yra-imones-finansine-sveikata-ir-kaip-ja-pagerinti",
    },
  ];
  return (
    <>
      <Typography variant="h3" color="primary" mb="3rem">
        6 patarimai, kad įmonės finansai taptų tvaresni
      </Typography>

      <Grid container columnSpacing={4} rowSpacing={10}>
        {config.map(({ id, title, text, readMore }) => (
          <Grid item xs={12} md={6} lg={4} key={title}>
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                backgroundColor: "background3.dark",
                borderRadius: "50% 50% 0 0",
                width: "36px",
                height: "32px",
              }}
            >
              <Typography color="primary.contrastText" mt="4px">
                {id}
              </Typography>
            </Stack>

            <Card
              secondary
              padding="0.6rem"
              sx={{
                height: "100%",
              }}
            >
              <Stack height="100%" justifyContent="space-between">
                <div>
                  <Typography variant="body2" fontWeight="700" mb="1rem">
                    {title}
                  </Typography>
                  <Typography variant="body2" fontWeight="400">
                    {text}
                  </Typography>
                </div>
                {readMore && (
                  <LinkButton href={readMore} small>
                    Skaityti daugiau
                  </LinkButton>
                )}
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
